import http from "../http-common";
import authHeader from "../../services/auth-header";

const getAll = (owner) => {
  if (!owner || owner === "undefined") return Promise.resolve({ data: [] });
  return http.get(`/speacc/${owner}` , { headers: authHeader() });
};

const get = (id) => {
  return http.get(`/speacc/${id}` , { headers: authHeader() });
};

const create = (owner, data) => {
  return http.post(`/speacc/${owner}`, data , { headers: authHeader() });
};

const update = (id, data) => {
  return http.put(`/speacc/${id}`, data , { headers: authHeader() });
};

const remove = (id) => {
  return http.delete(`/speacc/${id}` , { headers: authHeader() });
};

const removeAll = () => {
  return http.delete(`/speacc` , { headers: authHeader() });
};

const findByTitle = (title) => {
  return http.get(`/speacc?title=${title}` , { headers: authHeader() });
};

const SpeAccService = {
  getAll,
  get,
  create,
  update,
  remove,
  removeAll,
  findByTitle,
};

export default SpeAccService;
